import { FC } from 'react'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { memberDataSelector } from 'selectors/globalSelectors'
import { getRedirectAnchor } from 'helpers/pageHelpers'
import NavigationRedirect from 'components/atoms/navigation/NavigationRedirect'
import { withRouter, RouteComponentProps } from 'react-router'
import { makeUrlRelative } from 'helpers/utilsHelpers'

const OnboardingStepGuardInner: FC<RouteComponentProps<{}>> = (props) => {
  const { children } = props

  const memberData = useStoreSelector(memberDataSelector)
  const member = memberData ? memberData.info : null

  if (memberData && member && member.onboarding_step !== 'finished') {
    const redirectAnchor = getRedirectAnchor({
      url: makeUrlRelative(props.location),
      allowedStep: member.onboarding_step,
      previousStep: memberData.previousStep,
      isAuthenticated: true,
    })

    if (redirectAnchor !== null) {
      return (
        <NavigationRedirect to={ redirectAnchor } push />
      )
    }

  }

  return (
    <>{ children }</>
  )
}

export const OnboardingStepGuard = withRouter(OnboardingStepGuardInner)
